import { en } from './en';
import { ru } from './ru';
import { ua } from './ua';
import { pl } from './pl';
import { cz } from './cz';
import { md } from './md';
import { bg } from './bg';
import { kz } from './kz';

// Per-language fallback content for the CMS page renderer (de uses the
// inline German fallback in page.tsx).
export const content: Record<string, { title: string; subtitle?: string; sections: { id: string; title: string; body: string }[] }> = {
  en, ru, ua, pl, cz, md, bg, kz,
};
